import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosUrl from '../../axios/url';
import PropTypes from 'prop-types';
import TagBox from '../common/Util/TagBox';
import TagSelectModal from './modal/TagSelectModal';
import ScheduleShowLowTag from './ScheduleShowLowTag';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";



const arrWeek = ['월','화','수','목','금','토','일'];
const arrHour = ['00', '01','02','03','04','05', '06', '07', '08', '09' , '10',
                  '11', '12', '13' , '14', '15', '16', '17' , '18', '19', '20',
                  '21', '22', '23'];
const arrMinites = ['00', '30' ];


export default function ScheduleCreateBody(param) {

    var curUrl = window.location.href;
    var result = '';
    if( curUrl.indexOf('ScheduleCreateMessage') > -1)  result  = 'message';
    else  result = 'content';
    
    //시간
    const [selectType, setSelectType] = useState("WEEK");
    const [inputStyle, setInputStyle] = useState("form-control float-right d-none");
    const [week, setWeek] = useState('');
    const [weekday, setWeekDay] = useState('');
    const [day, setDay] = useState('');
    const [hour, setHour] = useState('');
    const [minute, setMinute] = useState('');
    const [eventText, setEventText] = useState("");
    const [reserved, setReserved] = useState('');
    const [projectId, setProjectId] = useState('');
    //설명
    const [title, setTitle] = useState("");
    //태그
    const [lowTagList, setLowTagList] = useState([]);
    const [representive, setRepresentive] = useState({});
    const [representiveList, setRepresentiveList] = useState([]);
    const [representiveCheck, setRepresentiveCheck] = useState(false); //태그삭제 못하게 변경하기 위해서
    //태그 생성시 이미지 수정
    const [tagCreateCheck, setTagCreateCheck] = useState("");
    const [sendData, setSendData] = useState("");
    // check
    const [check, setCheck] = useState(false);
    // erroe
    const [error, setError] = useState(false);

    //하위 태그들의 경우에수 만큼 생성
    function getPermutation(array, prefix) {
        prefix = prefix || '';
        if (!array.length) {
            return prefix;
        }

        var result = array[0].reduce(function (result, value) {
            if(prefix === '') {
                return result.concat(getPermutation(array.slice(1), prefix + value.name));
            } else {
                return result.concat(getPermutation(array.slice(1), prefix + "," + value.name));
            }
        }, []);
        return result;
    }

    // 
    function componentDidCatch(error, info) {
        // Something happened to one of my children.
        // Add error to state
        // this.setState({
        //     error: error,
        //     info: info,
        // });
        setError(error);
    }
    // 

    //스케줄 생성
    async function postscheduleCreate(saveData){

        // if(selectType === "WEEK") {
        //     if(week === ''){ alert('주차를 입력하세요.'); return;}
        //     if(weekday === '-1'){ alert('요일을 입력하세요.'); return;}
        //     if(hour === ''){ alert('시간을 입력하세요.'); return;}
        //     if(minute === ''){ alert('분을 입력하세요.'); return;}
        // } else if(selectType === "DAY") {

        // } else if(selectType === "WEEKDAY") {
            
        // } else if(selectType === "EVENT") {
            
        // } else if(selectType === "RESERVED") {
            
        // }
        // if(name === ''){ alert('하위태그 명을 입력하세요.'); return;}
        // if(description === ''){ alert('설명을 입력하세요.'); return;}

        // if(!window.confirm('하위태그를 수정하시겠습니까?')) return;
        // console.log(param.programId);
        var temp = curUrl.split("/");
        var programId = temp[temp.length-1];
        // scheduleRightSidebar  programId = param.programId
        await axios.post(axiosUrl.schedule_create+"/"+param.programId+"/schedules", saveData)
        .then( response => {
            console.log("create schedule success");
            goList();
            // alert("스케줄이 저장되었습니다.");
            // document.getElementById('close').click();
        })
        .catch(function (e) {
            alert("스케줄이 저장되지 않았습니다.");
            console.error('[MEDIEX_CMS_2019_ERROR] postscheduleCreate - ' + e);
            console.error('[MEDIEX_CMS_2019_ERROR] axiosUrl - ' + axiosUrl.project_list);
        });

    }

    useEffect(() => {                            
    }, [sendData])

    useEffect(() => {
        if(param.type == "RESERVED") {
            setInputStyle("form-control float-right");
        } else {
            setInputStyle("form-control float-right d-none");
        }
        setMinute('');
        setSelectType(param.type);
    }, [param.type])

    // ScheduleRightSidebar
    useEffect(() => {
        setWeek('');
        setWeekDay('');
        setDay('');
        setHour('');
        setMinute('');
        setEventText("");
        setReserved("");
        setTitle("");
        setLowTagList([]);
        setRepresentive({});
        setRepresentiveList([]);
        setRepresentiveCheck(false);
        setTagCreateCheck("");
        setSendData("");
        setCheck(false);
    }, [param.clear])

    //시간선택 변경시 초기화
    function selectTimeChange(e) {
        setSelectType(e.target.value);
        //조건 안으로 넣으면 데이터픽커가 작동이 안되서 css변경으로 함
        if( e.target.value === "RESERVED") {
            setInputStyle("form-control float-right")
        } else {
            setInputStyle("form-control float-right d-none")
        }
        setWeek();
        setWeekDay();
        setDay();
        setHour();
        setMinute();
        setEventText("");
        setReserved("");
    }

    function selectWeekChange(e) {
        setWeek(e.target.value);
    }

    function selectDayChange(e) {
        setDay(e.target.value);
    }

    function selectWeekDayChange(e) {
        setWeekDay(e.target.value);
    }

    function selectHourChange(e) {
        setHour(e.target.value);
    }

    function selectMinuteChange(e) {
        setMinute(e.target.value);
    }
    
    function selectEventTextChange(e) {
        setEventText(e.target.value);
    }

    function reservedHandleChange(date) {
        console.log(date);
        setReserved(date)
    }

    function titleChange(e) {
        setTitle(e.target.value);
    }

    function tagModalCreate() {
        setProjectId(param.projectId);
    }

    function lowTagAdd() {
        var temp = sendData;
        temp.push({message: '', messageList: [], contentList: [], contentId: '', contentTitle: "", check: '', lowTag: '', lowTagList: []});
        
        setSendData(sendData);
        setCheck(!check);
    }

    //상위태그를 선택하여 하위태그 생성
    function lowTagCreate() {
        if(representiveList.length === 0) {
            alert("태그을 생성해주세요.");
        } else {
            //선택 및 생성 버튼 사용못하게 하기 위하여
            setTagCreateCheck("d-none");
            //태그에서 하위태그 리스트 뽑아내기 위해서
            // [{id: "1", name: "name".....},{}]
            var result = representiveList.map((tag, i) => {
                return tag.tags;
            })

            var list = getPermutation(result);
            setLowTagList(list);
            setRepresentiveCheck(true); //태그 수정 못하게 하기 위해서

            var sendData = [];
            list.map((lowTag, i) => {
                var tempArr = lowTag.split(",");
                var temp = [];
                tempArr.map((tagName, i) => {
                    temp.push({id: tagName, text: tagName});
                })
                sendData.push({message: '', messageList: [], contentList: [], contentId: '', contentTitle: "", check: '', lowTag: lowTag, lowTagList: temp});
            })
            setSendData(sendData);
        }
        
    }
    function trim(stringToTrim) {
        return stringToTrim.replace(/^\s+|\s+$/g,"");
    }
    //스케줄 목록으로 이동
    function goList(){
        window.location = '/schedule/'+selectType+"/"+param.projectId+"/"+param.programId;
    }

    function scheduleSave() {
        if(trim(title) === ''){ alert('제목을 확인하세요.'); return;}
        if(sendData.length === 0 ){ alert('태그을 확인하세요.'); return;}
        var representiveString = "";
        var tags = [];
        var classification = "";
        var check = true;   //하위태그에 메모나 컨텐츠 들어갔는지 확인
        representiveList.map((tag, i) => {
            if(i === 0) {
                representiveString = representiveString + tag.name;
            } else {
                representiveString = representiveString +","+ tag.name;
            }
        })
        sendData.map((data, i) => {
            var tempList = [];
            if(trim(data.check) === ''){ 
                check = false;
            }
            if(check) {
                if(data.check === "content") {
                    classification = "CONTENTS";
                    data.contentList.map((content, j) => (
                        tempList.push({"contentId": content.contentId})
                    ))
                    tags.push({"tag": data.lowTag, "items": tempList});
                } else if(data.check === "message") {
                    classification = "MESSAGE";
                    data.messageList.map((message, j) => (
                        tempList.push({"body": message})
                    ))
                    tags.push({"tag": data.lowTag, "items": tempList});
                } else {
                    console.log( "sendData.map else");
                }
            }
            
        })

        if(check === false){ alert('하위 태그에 메세지 또는 컨텐츠을 전부 할당해 주세요.'); return;}
        
        var saveData = {
            "type": selectType,
            "classification": classification,
            "week": week,
            "day": day,
            "weekday": weekday,
            "hour": hour,
            "minute": minute,
            "eventValue" : eventText,
            "dateReserved" : reserved,
            "title": title,
            "representives": representiveString,
            "tags" : tags
        }
        
        
        postscheduleCreate(saveData);
    }

    // 대표태그를 추가하였을경우 
    function checkTagList(checkTag) {
        var tempList = representiveList;
        tempList.push(checkTag); 
        setRepresentiveList(tempList);
    }

    //검색을 통해서 선택된 태그
    function callbackCheckTag(checkTag) {
        var temp = {id: checkTag.name, text: checkTag.name};
        var arrTemp = representiveList;
        if(representiveList !== []) {
            var test = representiveList.filter(representive => {
                if(representive.name === checkTag.name) {
                    return representive;
                }
            })
            
            //같은 대표태그 추가 방지
            if(test.length > 0) {
                console.log("test > 0");
            } else {
                checkTagList(checkTag);
                setRepresentiveList(arrTemp);
                setRepresentive(temp);
            }
        } else {
            setRepresentiveList(arrTemp);
        }
    }

    function callbackDeleteTag(deleteTag) {
        // deleteTag = {id: "xxx", text: "xxx"}
        // representiveList = {id: 32, name:"xxx", ...}
        var tempList = representiveList.filter(tag => {
            if(tag.name !== deleteTag[0].id) {
                return Object.keys(tag);
            }
        });
        setRepresentiveList(tempList);
    }

    const callbackSendData = (data) => {
        setSendData(data);
    }

    return(
        <section className="content">
            <div className="row">

                {/* 시간에 따른 입력 창 (timeView) */}
                <div className="col-12">
                    <div className="card">
                        {/* content header */}
                        <div className="card-header contentColor">
                            <h3 className="card-title">시간</h3>
                        </div>
                        <div className="card-body">
                            <div className="time-select">
                                <div className="form-group">
                                    <label> 시간 : </label>
                                    <select value={selectType} onChange={selectTimeChange} className="form-control">
                                        <option value="WEEK">주</option>
                                        <option value="DAY">일</option>
                                        <option value="WEEKDAY">반복</option>
                                        <option value="EVENT">이벤트</option>
                                        <option value="RESERVED">예약</option>
                                    </select>
                                </div>
                            </div>
                            <div>
                                {/* 주 */}
                                {
                                    selectType === "WEEK" && <div className="time-select">
                                                                <div>
                                                                    <input className="form-control" id="exampleInputEmail1" placeholder="주차" onChange={selectWeekChange} value={week}/>
                                                                    <label>주차</label>
                                                                </div>
                                                                <div className="form-group">
                                                                    <select className="form-control" onChange={selectWeekDayChange} value={weekday}>
                                                                        <option value="-1"> </option>
                                                                        {arrWeek.map((row, i) => (
                                                                            <option key={i} value={i+1}>{row}</option>
                                                                        ))}
                                                                    </select>
                                                                    <label> 요일 </label>
                                                                </div>
                                                                <div className="form-group">
                                                                    <select className="form-control" onChange={selectHourChange} value={hour}>
                                                                        {arrHour.map((row, i) => (
                                                                            <option key={i} value={i}>{row}</option>
                                                                        ))}
                                                                    </select>
                                                                    <label> 시 </label>
                                                                </div>
                                                                <div className="form-group">
                                                                    <select className="form-control" onChange={selectMinuteChange} value={minute}>
                                                                        {arrMinites.map((row, i) => (
                                                                            <option key={i} value={row}>{row}</option>
                                                                        ))}
                                                                    </select>
                                                                    <label> 분 </label>
                                                                </div>
                                                            </div>
                                }
                                {/* 일 */}
                                { 
                                    selectType === "DAY" && <div className="time-select">
                                                                <div>
                                                                    <input className="form-control" id="exampleInputEmail1" placeholder="주차" onChange={selectDayChange} value={day}/>
                                                                    <label>주차</label>
                                                                </div>
                                                                <div className="form-group">
                                                                    <select className="form-control" onChange={selectHourChange} value={hour}>
                                                                        {arrHour.map((row, i) => (
                                                                            <option key={i} value={i}>{row}</option>
                                                                        ))}
                                                                    </select>
                                                                    <label> 시 </label>
                                                                </div>
                                                                <div className="form-group">
                                                                    <select className="form-control" onChange={selectMinuteChange} value={minute}>
                                                                        {arrMinites.map((row, i) => (
                                                                            <option key={i} value={row}>{row}</option>
                                                                        ))}
                                                                    </select>
                                                                    <label> 분 </label>
                                                                </div>
                                                            </div>
                                }
                                {/* 반복 */}
                                { 
                                    selectType === "WEEKDAY" && <div className="time-select">
                                                                <div className="form-group">
                                                                    <select className="form-control" onChange={selectWeekDayChange} value={weekday}>
                                                                        <option value="-1"> </option>
                                                                        {arrWeek.map((row, i) => (
                                                                            <option key={i} value={i+1}>{row}</option>
                                                                        ))}
                                                                    </select>
                                                                    <label> 요일 </label>
                                                                </div>
                                                                <div className="form-group">
                                                                    <select className="form-control" onChange={selectHourChange} value={hour}>
                                                                        {arrHour.map((row, i) => (
                                                                            <option key={i} value={i}>{row}</option>
                                                                        ))}
                                                                    </select>
                                                                    <label> 시 </label>
                                                                </div>
                                                                <div className="form-group">
                                                                    <select className="form-control" onChange={selectMinuteChange} value={minute}>
                                                                        {arrMinites.map((row, i) => (
                                                                            <option key={i} value={row}>{row}</option>
                                                                        ))}
                                                                    </select>
                                                                    <label> 분 </label>
                                                                </div>
                                                            </div>
                                }
                                {/* 이벤트 */}
                                { 
                                    selectType === "EVENT" && <input className="form-control" placeholder="이벤트명" onChange={selectEventTextChange} value={eventText}/>
                                }
                                    
                                {/* 예약 */}
                                <DatePicker className={inputStyle} selected={reserved} onChange={reservedHandleChange} dateFormat="yyyy-MM-dd" />
                            </div>
                        </div>
                    </div>
                </div>   

                {/* 상위태그 하위태그 보여주는곳(tagView)  */}
                <div className="col-12">
                    <div className="card">
                        {/* content header */}
                        <div className="card-header contentColor">
                            <h3 className="card-title">제목</h3>
                        </div>
                        <div className="card-body">
                            <div>
                                <input className="form-control"  placeholder="제목" value={title} onChange={titleChange}/>
                            </div>
                        </div>
                            
                    </div>
                    <div className="card">
                        {/* content header */}
                        <div className="card-header contentColor">
                            <h3 className="card-title">대표 태그</h3>
                        </div>
                        <div className="card-body">
                            {
                                tagCreateCheck !== 'd-none' ?
                                <div>  
                                    <div className="btn-group float-right zindex-100">
                                        <button type="button" className="btn btn-primary btn-select" onClick={lowTagCreate}>생성</button>
                                    </div>
                                    <div className="btn-group float-right zindex-100  mr-2">
                                        <button type="button" className="btn btn-primary btn-select" data-toggle="modal" data-target="#tagSelectModal" onClick={tagModalCreate}>검색</button>
                                    </div>
                                </div>
                                :
                                <div>  
                                    {/* <div className="btn-group float-right zindex-100">
                                        <button type="button" className="btn btn-primary btn-select" onClick={lowTagAdd}>하위태그 생성</button>
                                    </div> */}
                                    <div className="btn-group float-right zindex-100  mr-2">
                                        {/* <button type="button" className="btn btn-primary btn-select" data-toggle="modal" data-target="#tagSelectModal" onClick={tagModalCreate}>검색</button> */}
                                    </div>
                                </div>
                            }
                            <div id="tat-add-not">
                                <TagBox title="검색어" clear={param.clear} readCheck={representiveCheck} representive={representive} callbackDeleteTag={callbackDeleteTag}></TagBox>
                            </div>
                        </div>
                    </div>
                </div> 
                {/* 선택 버튼 (bottom view)*/}
                <div className="col-12">
                    <ScheduleShowLowTag clear={param.clear} contentCheck={param.contentCheck} sendData={sendData} callbackSendData={callbackSendData}></ScheduleShowLowTag>
                    <div className="button-wrapper mb-5 col-12"  >
                        <button type="button" className="btn btn-primary mr-1" onClick={() => scheduleSave()}><i className="fas fa-edit"></i> 새 스케줄 저장하기</button>
                        <button type="button" className="btn btn-primary" onClick={() => goList()}><i className="fas fa-list"></i> 목록</button>
                    </div>
                </div>
            </div>

            {/* 모달 */}
            <TagSelectModal callbackCheckTag={callbackCheckTag} projectId={projectId}></TagSelectModal>
            
        </section>
    );
}